import { render, staticRenderFns } from "./the-integrations.vue?vue&type=template&id=5a7b0b7a&scoped=true"
import script from "./the-integrations.vue?vue&type=script&lang=js"
export * from "./the-integrations.vue?vue&type=script&lang=js"
import style0 from "./the-integrations.vue?vue&type=style&index=0&id=5a7b0b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b0b7a",
  null
  
)

export default component.exports